<template>
  <div>
    <p class="text-muted">
      Conteste cada una de las siguientes preguntas:
    </p>
    <div class="form-group mb-4">
      <p>
        ¿En el proyecto se utilizará algún agente biológico: muestras clínicas o patológicas de origen humano o animal,
        aislamientos clínicos bacterianos, cepas bacterianas, líneas celulares, muestras ambientales, etc?
      </p>
      
      <!-- Question 1 -->
      <div class="form-check form-check-inline">
        <input id="question-1-radio-1" data-toggle="collapse"
               data-target=".question-1-collapse:not(.show)"
               name="question_1" type="radio" value="1"
               class="form-check-input show-collapse collapsed"
               aria-expanded="false"
               @change="changeQuestionValue('question_1', true)"
               :checked="questionnaire.question_1">
        <label for="question-1-radio-1"
               class="form-check-label">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-1-radio-2" data-toggle="collapse"
               data-target=".question-1-collapse.show"
               name="question_1" type="radio" value=""
               class="form-check-input"
                @change="changeQuestionValue('question_1', false)"
               :checked="questionnaire.question_1 === false">
        <label for="question-1-radio-2"
               class="form-check-label">No</label>
      </div>
      <div data-name="question_1"></div>
    </div>
    <div class="form-group mb-4">
      <p>
        ¿En el proyecto se usarán agentes biológicos modificados genéticamente en el laboratorio? (bacterias o parásitos
        recombinantes, plásmidos, vectores, líneas celulares, animales, etc.)
      </p>
      
      <!-- Question 2 -->
      <div class="form-check form-check-inline">
        <input id="question-2-radio-1" data-toggle="collapse"
               data-target=".question-2-collapse:not(.show)"
               name="question_2" type="radio" value="1"
               class="form-check-input show-collapse collapsed"
               aria-expanded="false"
               @change="changeQuestionValue('question_2', true)"
               :checked="questionnaire.question_2">
        <label for="question-2-radio-1"
               class="form-check-label">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-2-radio-2" data-toggle="collapse"
               data-target=".question-2-collapse.show"
               name="question_2" type="radio" value=""
               class="form-check-input"
               @change="changeQuestionValue('question_2', false)"
               :checked="questionnaire.question_2 === false">
        <label for="question-2-radio-2"
               class="form-check-label">No</label>
      </div>
      <div data-name="question_2"></div>
    </div>
    <div class="form-group mb-4">
      <p>
        ¿El proyecto contempla el USO de materiales peligrosos: Corrosivos, Reactivos, Explosivos, Tóxicos, Inflamables (CRETI)?
      </p>
      
      <!-- Question 3 -->
      <div class="form-check form-check-inline">
        <input id="question-3-radio-1" data-toggle="collapse"
               data-target=".question-3-collapse:not(.show)"
               name="question_3" type="radio" value="1"
               class="form-check-input show-collapse collapsed"
               aria-expanded="false"
               @change="changeQuestionValue('question_3', true)"
               :checked="questionnaire.question_3">
        <label for="question-3-radio-1"
               class="form-check-label">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-3-radio-2" data-toggle="collapse"
               data-target=".question-3-collapse.show"
               name="question_3" type="radio" value=""
               class="form-check-input"
               @change="changeQuestionValue('question_3', false)"
               :checked="questionnaire.question_3 === false">
        <label for="question-3-radio-2"
               class="form-check-label">No</label>
      </div>
      <div data-name="question_3"></div>
    </div>
    <div class="form-group mb-4">
      <p>
        ¿En el proyecto se utilizará alguna fuente de radiación ionizante, (rayos X, rayos gamma, partículas alfa, beta,
        neutrones o cualquier material radiactivo)?
      </p>
      
      <!-- Question 4 -->
      <div class="form-check form-check-inline">
        <input id="question-4-radio-1" data-toggle="collapse"
               data-target=".question-4-collapse:not(.show)"
               name="question_4" type="radio" value="1"
               class="form-check-input show-collapse collapsed"
               aria-expanded="false"
               @change="changeQuestionValue('question_4', true)"
               :checked="questionnaire.question_4">
        <label for="question-4-radio-1"
               class="form-check-label">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-4-radio-2" data-toggle="collapse"
               data-target=".question-4-collapse.show"
               name="question_4" type="radio" value=""
               class="form-check-input"
               @change="changeQuestionValue('question_4', false)"
               :checked="questionnaire.question_4 === false">
        <label for="question-4-radio-2"
               class="form-check-label">No</label>
      </div>
      <div data-name="question_4"></div>
    </div>
    <div class="form-group mb-4"
         v-if="!questionnaire.question_1 && !questionnaire.question_2 && !questionnaire.question_3 && !questionnaire.question_4">
        <p class="font-weight-bold">
          Si la respuesta es "NO" a las cuatro preguntas anteriores descargue el siguiente formato, firmelo y subalo a la plataforma
          dando click en "Seleccionar documento".
          <br>
          <a href="/assets/data/biosecurity_questionnaire/formato_cuestionario_de_bioseguridad.pdf"
             class="font-weight-normal"
             target="_blank">
            <i class="fas fa-file-pdf text-danger"></i>
            Descargar formato
          </a>
        </p>
  
        <div class="alert alert-warning" role="alert"
             v-if="questionnaire.general_letter_path">
          Se ha cargado previamente una <strong>
          <a :href="`/${questionnaire.general_letter_path}`"
             target="_blank">
            Carta responsiva</a></strong>, para cambiar este archivo de click en "Seleccionar documento"
        </div>
  
        <div class="custom-file">
          <input data-id="general_letter"
                 accept="application/pdf"
                 name="general_letter"
                 type="file"
                 id="general_letter"
                 ref="general_letter"
                 class="custom-file-input"
                 data-target="general_letter"
                 data-text="Incorpore la carta responsiva de la(s) Institución(es) colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos."
                 data-info="general_letter_info"
                 @change="setFile('general_letter')">
          <label for="general_letter" class="custom-file-label">Seleccionar documento</label>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { AlertManager } from '../../../utils/AlertManager'
  import autosize from 'autosize'

  export default {
    name: 'SectionOne',
    props: {
      questionnaire: Object,
    },
    data: () => ({}),
    computed: {
      ...mapGetters(['user']),
    },
    methods: {
      changeQuestionValue (question, value) {
        this.questionnaire[question] = value
      },
      setFile (field) {
        const file = this.$refs[field].files[0]

        if(file.type.indexOf('pdf') === -1) {
          AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
            timeout: 10000,
          })

          $(this.$refs[field]).val('')
          
          return
        }
        
        if (!this.checkFileSize(file)) {
          AlertManager.error(`El tamaño máximo de archivo es de ${ (this.isAdmin() ? 5 : 2) }MB`)
          
          $(this.$refs[field]).val('')

          return
        }
        
        if(!this.checkFileType(file)) {
          AlertManager.error('Seleccione un archivo PDF.')
          
          $(this.$refs[field]).val('')

          return
        }

        this.questionnaire[field] = file
      },
      checkFileSize(file) {
        let maxFileSize = (this.isAdmin() ? 5 : 2) * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    mounted() {
      const vm = this
      const $formBio = $('.biosecurity-form')
      
      autosize($('textarea', this.$el))

      $formBio.validate({
        ignore: [],
        highlight: function (element) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (error, element) {
          if (element.is(':radio') || element.is(':checkbox')) {
            error.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            error.insertAfter(element)
          }

          error.addClass('invalid-feedback')
        },
        rules: {
          question_1: {
            required: true,
          },
          question_2: {
            required: true,
          },
          question_3: {
            required: true,
          },
          question_4: {
            required: true,
          },
          question_5: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_6: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_7: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_8: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_9: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_10: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
            },
          },
          question_11: {
           required: function () {
              return !!vm.questionnaire.question_3
            },
          },
          question_12: {
           required: function () {
              return !!vm.questionnaire.question_4
            },
          },
          question_13: {
           required: function () {
              return !!vm.questionnaire.question_1
                && !!vm.questionnaire.question_2
                && !!vm.questionnaire.question_3
                && !!vm.questionnaire.question_4
            },
          },
        },
        messages: {
          question_1: {
            required: 'Seleccione una opción',
          },
          question_2: {
            required: 'Seleccione una opción',
          },
          question_3: {
            required: 'Seleccione una opción',
          },
          question_4: {
            required: 'Seleccione una opción',
          },
          question_5: {
            required: 'Seleccione una opción',
          },
          question_6: {
            required: 'Seleccione una opción',
          },
          question_7: {
            required: 'Seleccione una opción',
          },
          question_8: {
            required: 'Seleccione una opción',
          },
          question_9: {
            required: 'Seleccione una opción',
          },
          question_10: {
            required: 'Seleccione una opción',
          },
          question_11: {
            required: 'Seleccione una opción',
          },
          question_12: {
            required: 'Seleccione una opción',
          },
          question_13: {
            required: 'Seleccione una opción',
          },
        },
        invalidHandler: function(event, validator) {
          const firstErrorName = Object.keys(validator.errorMap)[0]

          // Remove active classes from tab panes and nav tabs
          $('.biosecurity-form .tab-pane').removeClass('active')
          $('.biosecurity-form .nav-tabs .nav-link').removeClass('active')

          // Add class active to first tab with error
          const parentTabPane = $('[name="' + firstErrorName + '"]').closest('.tab-pane')
          const navLink = $('a[href="#' + parentTabPane.attr('id') + '"]')

          parentTabPane.addClass('active')
          navLink.addClass('active')
        },
      })

      $formBio.find('#general_letter').rules('add', {
        required: function () {
          return $('[name="question_1"]:checked').val() === '' &&
                 $('[name="question_2"]:checked').val() === '' &&
                 $('[name="question_3"]:checked').val() === '' &&
                 $('[name="question_4"]:checked').val() === '' &&
                 !vm.questionnaire.general_letter_path
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
    },
  }
</script>
